import { type ReactNode } from 'react'
import { TableHost } from '@/components/Table'
import styles from './TableTab.module.css'

export interface TableTabProps {
  toolbar: ReactNode
  children: ReactNode
}

/**
 * A details tab that lists a table under a toolbar.
 */
export function TableTab({ toolbar, children }: TableTabProps) {
  return (
    <>
      <div className={styles.toolbar}>{toolbar}</div>
      <div className={styles.table}>
        <TableHost>{children}</TableHost>
      </div>
    </>
  )
}
